import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconoirSort = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 39,
			height: 39,
			rx: 7.5,
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 39,
			height: 39,
			rx: 7.5,
			stroke: "#0A0A0A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 22H10M16 18H10M14 14H10M20 26H10M27 28V12M27 28L30 25M27 28L24 25M27 12L30 15M27 12L24 15",
			stroke: "#0A0A0A",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconoirSort;
